import { render, staticRenderFns } from "./MemberAdd.vue?vue&type=template&id=582836c2&scoped=true"
import script from "./MemberAdd.vue?vue&type=script&lang=js"
export * from "./MemberAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582836c2",
  null
  
)

export default component.exports